import Player from '@vimeo/player';

export default class Video {
    constructor() {
        this.init();
        this.show();
        this.hide();
    }

    init() {
        const videoWrapper = document.querySelector('#salle .video-full .movie');
        if (videoWrapper) {
            const options = {
                id: videoWrapper.dataset.id,
                width: 640,
                loop: false
            };

            this.player = new Player('full-video', options);
        }
    }

    show() {
        const playBtn = document.querySelector('#salle .video .play');
        if (playBtn) {
            playBtn.addEventListener('click', () => {
                document.querySelector('#salle .video-full').style.display = 'block';
                this.player.play();
            });
        }
    }

    hide() {
        const overlayBtn = document.querySelector('#salle .video-full .overlay');
        if (overlayBtn) {
            overlayBtn.addEventListener('click', () => {
                document.querySelector('#salle .video-full').style.display = 'none';
                this.player.unload();
            });
        }
    }
}